import Character from '@/models/Character';
import axios from 'axios';

export const useCharacters = (): Character[] => [
    { url: '/assets/img/Betty.png', id: 1, name: 'Betty' },
    { url: '/assets/img/Jonas.png', id: 2, name: 'Jonas'  },
    { url: '/assets/img/Hansel.png', id: 3, name: 'Hansel'  },
    { url: '/assets/img/Janet.png', id: 4, name: 'Janet'  },
];

export const api = () => {
    const instance = axios.create({
        baseURL: 'https://back-50-50.homedev-sn.com/api',
        // baseURL: 'http://localhost:8000/api',
    });

    instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    instance.defaults.headers.common['Accept']           = 'application/json';
   
    instance.interceptors.response.use(response => Promise.resolve(response.data), error => {
        const { response } = error;

        if(response.status === 401) return Promise.reject({ status: 401, errors: ['Unauthorized']});

        if(response.status === 422) {
            const errors = response?.data?.errors;
            return Promise.reject({ status: 422, errors: Object.keys(errors).map(key => errors[key][0] ?? false).filter(Boolean) });
        }

        if(response.status === 500) {
            return Promise.reject({ status: 500, errors: [response?.data?.message || 'Oups'] });
        }

        return Promise.reject({ status: response.status, errors: ['Oups!'] });
    });

    return instance;
};
